import { ref } from 'vue'

// Store notifications in a reactive array
const notifications = ref([])
let nextId = 1

export function useToast() {
  /**
   * Add a new notification
   * @param {string} message - The notification message
   * @param {string} type - The notification type (success, error, warning, info)
   * @param {number} timeout - Auto dismiss timeout in milliseconds
   * @returns {number} - The notification ID
   */
  const add = (message, type = 'info', timeout = 5000) => {
    const id = nextId++

    notifications.value.push({
      id,
      message,
      type,
      timestamp: Date.now()
    })

    if (timeout > 0) {
      setTimeout(() => remove(id), timeout)
    }

    return id
  }

  /**
   * Remove a notification by ID
   * @param {number} id - The notification ID to remove
   */
  const remove = (id) => {
    const index = notifications.value.findIndex(notification => notification.id === id)
    if (index !== -1) {
      notifications.value.splice(index, 1)
    }
  }

  /**
   * Clear all notifications
   */
  const clear = () => {
    notifications.value = []
  }

  // Shortcuts for different notification types
  const success = (message, timeout = 5000) => add(message, 'success', timeout)
  const error = (message, timeout = 5000) => add(message, 'error', timeout)
  const info = (message, timeout = 5000) => add(message, 'info', timeout)
  const warning = (message, timeout = 5000) => add(message, 'warning', timeout)

  return {
    notifications,
    add,
    remove,
    clear,
    success,
    error,
    info,
    warning
  }
}
